import { useContext, useState } from "react";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  tempUrlFico,
  useStateContext,
} from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Alert, Button, Snackbar, Typography } from "@mui/material";
import DatePicker from "react-datepicker";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import useScreenWidth from "../../../hooks/useScreenWidth";

const POSTING_PENJUALAN_CHUNK_DAYS = 7;

const addDays = (date, days) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

const formatDateForRequest = (date) => {
  const newDate = new Date(date);
  const pad = (value) => value.toString().padStart(2, "0");

  return `${newDate.getFullYear()}-${pad(newDate.getMonth() + 1)}-${pad(
    newDate.getDate()
  )}`;
};

const getPostingPenjualanDateChunks = (startDate, endDate) => {
  const chunks = [];
  let chunkStart = new Date(startDate);
  const finalDate = new Date(endDate);

  while (chunkStart <= finalDate) {
    const chunkEnd = addDays(chunkStart, POSTING_PENJUALAN_CHUNK_DAYS - 1);
    chunks.push({
      dariTanggal: formatDateForRequest(chunkStart),
      sampaiTanggal: formatDateForRequest(
        chunkEnd > finalDate ? finalDate : chunkEnd
      ),
    });
    chunkStart = addDays(chunkEnd, 1);
  }

  return chunks;
};

const Posting = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [validated, setValidated] = useState(false);
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [openErrorInput, setOpenErrorInput] = useState(false);
  const [vertical] = useState("bottom");
  const [horizontal] = useState("center");

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleCloseError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenError(false);
  };

  const handleCloseErrorInput = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorInput(false);
  };

  const posting = async (e) => {
    let countNeracaSaldo = 0;
    var lastday = function (y, m) {
      return new Date(y, m, 0).getDate();
    };
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      try {
        let isDariTglBiggerThanSampaiTgl = dariTanggal > sampaiTanggal;
        if (isDariTglBiggerThanSampaiTgl) {
          setOpenErrorInput(true);
        } else {
          setLoading(true);
          let tempPersenLoading = parseInt(persenLoading);
          console.log("setting");
          console.log(setting);
          // Jurnal Posting Pembelian
          await axios.post(`${tempUrlFico}/saveJurnalPostingPembelian`, {
            persediaan: setting.persediaan,
            hutangDagang: setting.hutangDagang,
            pendapatanLainLainPotonganPembelian:
              setting.pendapatanLainLainPotonganPembelian,
            ppnMasukan: setting.ppnMasukan,
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Retur Pembelian
          await axios.post(`${tempUrlFico}/saveJurnalPostingReturPembelian`, {
            persediaan: setting.persediaan,
            hutangDagang: setting.hutangDagang,
            pendapatanLainLainPotonganPembelian:
              setting.pendapatanLainLainPotonganPembelian,
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Pembayaran Hutang
          await axios.post(`${tempUrlFico}/saveJurnalPostingPembayaranHutang`, {
            hutangDagang: setting.hutangDagang,
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Penjualan
          const postingPenjualanChunks = getPostingPenjualanDateChunks(
            dariTanggal,
            sampaiTanggal
          );

          for (const postingPenjualanChunk of postingPenjualanChunks) {
            await axios.post(`${tempUrlFico}/saveJurnalPostingPenjualan`, {
              persediaan: setting.persediaan,
              piutangUsaha: setting.piutangUsaha,
              kas: setting.kas,
              bank: setting.bank,
              hpp: setting.hpp,
              hutangBiayaCc: setting.hutangBiayaCc,
              penjualan: setting.penjualan,
              pendapatanJasaServis: setting.pendapatanJasaServis,
              potonganPenjualan: setting.potonganPenjualan,
              piutangAffiliasiSjm: setting.piutangAffiliasiSjm,
              ...postingPenjualanChunk,
              userIdInput: user.id,
              _id: user.id,
              token: user.token,
              kodeCabang: user.cabang.id,
            });
          }
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Pembayaran Piutang
          await axios.post(
            `${tempUrlFico}/saveJurnalPostingPembayaranPiutang`,
            {
              piutangUsaha: setting.piutangUsaha,
              dariTanggal,
              sampaiTanggal,
              userIdInput: user.id,
              _id: user.id,
              token: user.token,
              kodeCabang: user.cabang.id,
            }
          );
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Mutasi Stok
          await axios.post(`${tempUrlFico}/saveJurnalPostingMutasiStok`, {
            persediaan: setting.persediaan,
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Jurnal Umum
          await axios.post(`${tempUrlFico}/saveJurnalPostingJurnalUmumRebuild`, {
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Kas Masuk
          await axios.post(`${tempUrlFico}/saveJurnalPostingKasMasukRebuild`, {
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Kas Keluar
          await axios.post(`${tempUrlFico}/saveJurnalPostingKasKeluarRebuild`, {
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Bank Masuk
          await axios.post(`${tempUrlFico}/saveJurnalPostingBankMasukRebuild`, {
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          // Jurnal Posting Bank Keluar
          await axios.post(`${tempUrlFico}/saveJurnalPostingBankKeluarRebuild`, {
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());

          const allNeracaSaldo = await axios.post(
            `${tempUrlFico}/neracaSaldoAboveTanggal`,
            {
              dariTanggal,
              sampaiTanggal,
              _id: user.id,
              token: user.token,
              kodeCabang: user.cabang.id,
            }
          );
          const deletedNeracaSaldoAboveTanggal = await axios.post(
            `${tempUrlFico}/deleteNeracaSaldoAboveTanggal`,
            {
              dariTanggal,
              sampaiTanggal,
              _id: user.id,
              token: user.token,
              kodeCabang: user.cabang.id,
            }
          );
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());

          const groupedNeracaSaldo = allNeracaSaldo.data.reduce(
            (group, neracaSaldo) => {
              const { tglNeracaSaldo } = neracaSaldo;
              group[tglNeracaSaldo] = group[tglNeracaSaldo] ?? [];
              group[tglNeracaSaldo].push(neracaSaldo);
              return group;
            },
            {}
          );
          let keys = Object.keys(groupedNeracaSaldo);

          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());

          console.log(`countNeracaSaldo: ${countNeracaSaldo}`);
          console.log(
            `Object.keys(groupedNeracaSaldo).length: ${
              Object.keys(groupedNeracaSaldo).length
            }`
          );
          // if (countNeracaSaldo === 0) {
          console.log(`dariTanggal: ${dariTanggal}`);
          console.log(`sampaiTanggal: ${sampaiTanggal}`);
          // Make Last Neraca Saldo
          await axios.post(`${tempUrlFico}/saveLastNeracaSaldoRebuild`, {
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          });
          // Update Neraca Saldo Jurnal Posting
          await axios.post(
            `${tempUrlFico}/saveJurnalPostingNeracaSaldoRebuild2`,
            {
              dariTanggal,
              sampaiTanggal,
              userIdInput: user.id,
              _id: user.id,
              token: user.token,
              kodeCabang: user.cabang.id,
            }
          );
          tempPersenLoading += 5;
          setPersenLoading(tempPersenLoading.toString());
          setLoading(false);
          setOpen(true);
          setPersenLoading("0");
        }
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpenError(!openError);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Accounting</h3>
      <h5 style={{ fontWeight: 400 }}>Posting</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Card>
        <Card.Header>Rentang Tanggal</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={posting}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Dari :
                  </Form.Label>
                  <Col sm="9">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={dariTanggal}
                      minDate={new Date(user.tutupperiode.dariTanggal)}
                      maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                      customInput={<Form.Control required />}
                      onChange={(date) => setDariTanggal(date)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Sampai :
                  </Form.Label>
                  <Col sm="9">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={sampaiTanggal}
                      minDate={new Date(user.tutupperiode.dariTanggal)}
                      maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                      customInput={<Form.Control required />}
                      onChange={(date) => setSampaiTanggal(date)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<DriveFileRenameOutlineIcon />}
                type="submit"
                disabled={
                  new Date(user.tutupperiode.dariTanggal) <
                  new Date(setting.programDariTanggal)
                    ? true
                    : false
                }
              >
                Posting
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Jurnal berhasil diposting!
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorInput}
        autoHideDuration={6000}
        onClose={handleCloseErrorInput}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert
          onClose={handleCloseErrorInput}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Sampai Tanggal tidak boleh lebih besar Dari Tanggal
        </Alert>
      </Snackbar>
      {error && (
        <Snackbar
          open={openError}
          autoHideDuration={6000}
          onClose={handleCloseError}
        >
          <Alert onClose={handleCloseError} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default Posting;

const spacingTop = {
  mt: 4,
};

const subTitleText = {
  fontWeight: "900",
};

const alertBox = {
  width: "100%",
};
